const CURRENCY_FORMATTER = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency',
  currencyDisplay: 'symbol' // Ensures only $ symbol is displayed
})

export const formatCurrency = (number: number): string => {
  return CURRENCY_FORMATTER.format(number)
}